import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacebookConnectComponent } from '@app/core/user/components/facebook-connect/facebook-connect.component';
import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';
import { SharedModule } from '@app/shared/shared.module';

import { getAuthServiceConfigs } from '@app/core/user/components/facebook-connect/AppConfigs';

@NgModule({
  imports: [CommonModule, SharedModule, SocialLoginModule],
  exports: [FacebookConnectComponent],
  declarations: [FacebookConnectComponent],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: getAuthServiceConfigs
    }
  ]
})
export class FacebookConnectModule {}
